import { render, staticRenderFns } from "./EntryHistoryCompare.vue?vue&type=template&id=a4386a78&scoped=true"
import script from "./EntryHistoryCompare.vue?vue&type=script&lang=js"
export * from "./EntryHistoryCompare.vue?vue&type=script&lang=js"
import style0 from "./EntryHistoryCompare.vue?vue&type=style&index=0&id=a4386a78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4386a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4386a78')) {
      api.createRecord('a4386a78', component.options)
    } else {
      api.reload('a4386a78', component.options)
    }
    module.hot.accept("./EntryHistoryCompare.vue?vue&type=template&id=a4386a78&scoped=true", function () {
      api.rerender('a4386a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/EntryHistoryCompare.vue"
export default component.exports